import axios from 'axios/dist/axios';


const defaultState = {
    summaryDataNew: null,
    summaryDataTranslated: null,
    mustShowRestrictedAccessPopup: false,
    assessmentVersion: null
};

// ======================================================================
// Initial State
// ======================================================================

const state = {
    summaryDataNew:                 defaultState.summaryDataNew,
    summaryDataTranslated:          defaultState.summaryDataTranslated,
    mustShowRestrictedAccessPopup:  defaultState.mustShowRestrictedAccessPopup,
    assessmentVersion:              defaultState.assessmentVersion
};


// ======================================================================
// Getters
// ======================================================================

const getters = {
    getSummaryDataNew:                  state => state.summaryDataNew,
    getSummaryDataTranslated:           state => state.summaryDataTranslated,
    getMustShowRestrictedAccessPopup:   state => state.mustShowRestrictedAccessPopup,
    getAssessmentVersion:               state => state.assessmentVersion

};


// ======================================================================
// Actions
// ======================================================================

const actions = {

    loadSummaryDataNew ({ commit, dispatch }, requestParamsObj) {
        let promise = new Promise((resolve, reject) => {

            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessmentSummary', requestParamsObj);
            axiosRequest.then((response) => {
                if (typeof response.data.data !== "undefined") {

                    let summaryData = response.data.data.SUMMARY;
                    let decisionItems3 = [];
                    let decisionItems4 = [];
                    if (summaryData.scoring != null && summaryData.scoring.scoringData != null && summaryData.scoring.scoringData.decisions != null) {
                        decisionItems3 = summaryData.scoring.scoringData.decisions.decisionItems3 || [];
                        decisionItems4 = summaryData.scoring.scoringData.decisions.decisionItems4 || [];
                        // We separate each decisionItems3 and decisionItems4 array into 2 arrays
                        // decisionItems3Recommended, decisionItems3Possible, decisionItems4Recommended, decisionItems4Possible
                        const {decisionItems3Recommended, decisionItems3Possible, decisionItems4Recommended, decisionItems4Possible} = this._vm.$DecisionItemHelperPlugin.splitDecisionItems(decisionItems3, decisionItems4, 'mandatory');

                        // We add the 2 arrays to the summary data object
                        summaryData.scoring.scoringData.decisions['decisionItems3Recommended'] = decisionItems3Recommended;
                        summaryData.scoring.scoringData.decisions['decisionItems3Possible'] = decisionItems3Possible;
                        summaryData.scoring.scoringData.decisions['decisionItems4Recommended'] = decisionItems4Recommended;
                        summaryData.scoring.scoringData.decisions['decisionItems4Possible'] = decisionItems4Possible;
                    }


                    commit('setSummaryDataNew', summaryData);
                    commit('setAssessmentVersion', response.data.data.SUMMARY.overview.assessmentVersion);

                    resolve(response);
                }
                else {
                    if (typeof response.data.returnCode !== "undefined" && response.data.returnCode === 262) {
                        reject("Assessment not found.");
                    }
                    else {
                        reject("Couldn't retrieve assessment data.");
                    }
                }

            });
            axiosRequest.catch((error) => {
                if (error.serverResponse.data.returnCode === 109) {
                    commit("setMustShowRestrictedAccessPopup", true);
                }
            });
        });

        return promise;
    },

    loadSummaryDataTranslated ({ commit, dispatch }, requestParamsObj) {
        let promise = new Promise((resolve, reject) => {

            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessmentSummary', requestParamsObj);
            axiosRequest.then((response) => {
                if (typeof response.data.data !== "undefined" && typeof response.data.data.SUMMARY !== "undefined") {

                    let summaryData = response.data.data.SUMMARY;
                    let decisionItems3 = [];
                    let decisionItems4 = [];
                    if (summaryData.scoring != null && summaryData.scoring.scoringData != null && summaryData.scoring.scoringData.decisions != null) {
                        decisionItems3 = summaryData.scoring.scoringData.decisions.decisionItems3 || [];
                        decisionItems4 = summaryData.scoring.scoringData.decisions.decisionItems4 || [];
                        // We separate each decisionItems3 and decisionItems4 array into 2 arrays
                        // decisionItems3Recommended, decisionItems3Possible, decisionItems4Recommended, decisionItems4Possible
                        const {decisionItems3Recommended, decisionItems3Possible, decisionItems4Recommended, decisionItems4Possible} = this._vm.$DecisionItemHelperPlugin.splitDecisionItems(decisionItems3, decisionItems4, 'mandatory');

                        // We add the 2 arrays to the summary data object
                        summaryData.scoring.scoringData.decisions['decisionItems3Recommended'] = decisionItems3Recommended;
                        summaryData.scoring.scoringData.decisions['decisionItems3Possible'] = decisionItems3Possible;
                        summaryData.scoring.scoringData.decisions['decisionItems4Recommended'] = decisionItems4Recommended;
                        summaryData.scoring.scoringData.decisions['decisionItems4Possible'] = decisionItems4Possible;
                    }

                    commit('setSummaryDataTranslated', summaryData);

                    resolve(response);
                }
                else {
                    if (typeof response.data.returnCode !== "undefined" && response.data.returnCode === 262) {
                        reject("Assessment translation not found.");
                    }
                    else {
                        reject("Couldn't retrieve assessment translation data.");
                    }
                }
            });
            axiosRequest.catch((error) => {
                if (error.serverResponse.data.returnCode === 109) {
                    commit("setMustShowRestrictedAccessPopup", true);
                }
            });
        });

        return promise;
    }

};


// ======================================================================
// Mutations
// ======================================================================

const mutations = {

    // ----------- Summary Data: -----------

    setSummaryDataNew (state, data) {
        state.summaryDataNew = data;
    },
    setSummaryDataTranslated (state, data) {
        state.summaryDataTranslated = data;
    },
    resetSummaryDataTranslated (state, data) {
        state.summaryDataTranslated = defaultState.summaryDataTranslated;
    },

    setMustShowRestrictedAccessPopup(state, data) {
        state.mustShowRestrictedAccessPopup = data;
    },
    setAssessmentVersion(state, data) {
        state.assessmentVersion = data;
    },

    // ----------------------------------------------------------

    resetStore (state) {
        state.summaryDataNew = defaultState.summaryDataNew;
        state.summaryDataTranslated = defaultState.summaryDataTranslated;
        state.mustShowRestrictedAccessPopup = defaultState.mustShowRestrictedAccessPopup;
    }
};


// ======================================================================
// Exports
// ======================================================================

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/common/store/modules/SummaryStore.js